export default "__VITE_ASSET__a145f109__"